import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import CSS from './TextArea.scss';
const TextArea = ({ style, testId, className, value, onChange, onFinalChange, onFocus, focused = false, stopPropagation = false, disabled = false, onBlur, onKeyUp, onKeyDown, onPointerDown, onMount, error, placeholder, }) => {
    const textAreaRef = useRef(null);
    const [userInput, setUserInput] = useState(false);
    const [tempValue, setTempValue] = useState(value);
    const classes = [CSS.TextArea, className ? className : '', disabled ? CSS.Disabled : ''];
    useEffect(() => {
        if (!userInput && tempValue !== value)
            setTempValue(value);
    }, [userInput, tempValue, value]);
    useEffect(() => {
        if (focused && textAreaRef.current)
            textAreaRef.current.focus();
    }, [focused, textAreaRef]);
    useEffect(() => {
        if (onMount && textAreaRef.current !== null)
            onMount(textAreaRef);
    }, [textAreaRef]);
    const _onFocus = (e) => onFocus?.(e);
    const _onBlur = (e) => {
        setUserInput(false);
        onBlur?.(e);
        if (onFinalChange && tempValue !== value)
            onFinalChange(e);
    };
    const _onChange = (e) => {
        setUserInput(true);
        onChange?.(e);
        setTempValue(e.target.value);
    };
    const _onKeyDown = (e) => {
        if (stopPropagation)
            e.stopPropagation();
        if (e.key === 'Enter' && !(e.metaKey || e.shiftKey) && textAreaRef.current) {
            e.preventDefault();
            textAreaRef.current.blur();
        }
        if (onKeyDown)
            onKeyDown(e);
    };
    const _onPointerDown = (e) => {
        if (stopPropagation)
            e.stopPropagation();
        onPointerDown?.(e);
    };
    return (_jsx("textarea", { "data-testid": testId ? testId : 'TextArea', ref: textAreaRef, style: { ...style, borderColor: error ? 'red' : '' }, className: classes.join(' '), value: tempValue, placeholder: placeholder, disabled: disabled || undefined, onFocus: _onFocus, onBlur: _onBlur, onChange: _onChange, onKeyDown: _onKeyDown, onKeyUp: (e) => {
            if (onKeyUp)
                onKeyUp(e);
        }, onPointerDown: _onPointerDown }));
};
export default TextArea;
